
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.5 8.5a.5.5 0 01.47.327.501.501 0 01.03.199 6.026 6.026 0 01-12 0 .5.5 0 01.5-.526h11zm-9-2A2.619 2.619 0 009.25 5c0-1.195-1.5-1.805-1.5-3A2.619 2.619 0 018.5.5m7 6a2.619 2.619 0 00.75-1.5c0-1.195-1.5-1.805-1.5-3A2.619 2.619 0 0115.5.5m-3.5 6a2.619 2.619 0 00.75-1.5c0-1.195-1.5-1.805-1.5-3A2.619 2.619 0 0112 .5m-7.5 23l4.631-9.726M19.5 23.5l-4.631-9.726m3.202 6.726H5.929","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    